"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibleUserToJSON = exports.EligibleUserFromJSONTyped = exports.EligibleUserFromJSON = void 0;
var runtime_1 = require("../runtime");
function EligibleUserFromJSON(json) {
    return EligibleUserFromJSONTyped(json, false);
}
exports.EligibleUserFromJSON = EligibleUserFromJSON;
function EligibleUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': !(0, runtime_1.exists)(json, '_id') ? undefined : json['_id'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'currentFuelBalance': !(0, runtime_1.exists)(json, 'currentFuelBalance') ? undefined : json['currentFuelBalance'],
        'hasIndustryPass': !(0, runtime_1.exists)(json, 'hasIndustryPass') ? undefined : json['hasIndustryPass'],
        'meetsRequirements': !(0, runtime_1.exists)(json, 'meetsRequirements') ? undefined : json['meetsRequirements'],
    };
}
exports.EligibleUserFromJSONTyped = EligibleUserFromJSONTyped;
function EligibleUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'email': value.email,
        'name': value.name,
        'currentFuelBalance': value.currentFuelBalance,
        'hasIndustryPass': value.hasIndustryPass,
        'meetsRequirements': value.meetsRequirements,
    };
}
exports.EligibleUserToJSON = EligibleUserToJSON;
